/**
 * Wrap base SQL for client-side sort via POST /api/query/execute-sql.
 * Backend strips LIMIT/OFFSET from the inner query and applies request offset/limit.
 *
 * @param {string} baseSql - final_generated_sql_query from /api/query/
 * @param {string} columnName - Column to ORDER BY (sanitized label)
 * @param {"asc"|"desc"|"ASC"|"DESC"} sortDirection
 * @param {number|null} userLimit - Optional row cap (also sent as request limit on first fetch)
 * @returns {string}
 */
export function buildSortedSQL(baseSql, columnName, sortDirection, userLimit = null) {
  const order = String(sortDirection ?? "")
    .trim()
    .toUpperCase();
  if (!["ASC", "DESC"].includes(order)) {
    throw new Error(`sort_order must be 'asc' or 'desc', got: '${sortDirection}'`);
  }

  const col = String(columnName ?? "").trim();
  if (!col) {
    throw new Error("column name is required for sort");
  }

  if (userLimit !== null && userLimit !== undefined) {
    const n = Number(userLimit);
    if (!Number.isInteger(n) || n < 1) {
      throw new Error(`limit must be a positive integer, got: ${userLimit}`);
    }
  }

  const inner = String(baseSql ?? "").replace(/[;\s]+$/, "");
  let sql = `SELECT * FROM (${inner}) AS t ORDER BY \`${col}\` ${order}`;
  if (userLimit != null && userLimit !== "") {
    sql += ` LIMIT ${Number(userLimit)}`;
  }
  return sql;
}
